import type { CSSProperties, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { claseLema, claseLemaPie } from './gaviCss';

/** Retraso de entrada de cada frase (s), como la maqueta. */
export const RETRASOS_LEMA = [0.5, 1.3, 2.1] as const;

type LemaRepiteProps = {
  /** Sin animación (ya se vio una vez, p. ej. al volver a pintar). */
  quieto?: boolean;
  /** Frase pequeña debajo (p. ej. «Y lo que gastes, apúntalo…»). */
  pie?: ReactNode;
  style?: CSSProperties;
};

/**
 * Lema de Rumbo, frase a frase: «Tu dinero.» · «Tus decisiones.» · «Tu
 * rumbo.» (la última, más grande y en acento). Quieto con «reducir
 * movimiento». Las frases se leen en orden con el lector de pantalla.
 */
export function LemaRepite({ quieto = false, pie, style }: LemaRepiteProps) {
  const { t } = useTranslation();
  const frases = [t('Your money.'), t('Your decisions.'), t('Your course.')];
  return (
    <>
      <div
        className={quieto ? `${claseLema} quieto` : claseLema}
        data-testid="lema"
        style={style}
      >
        {frases.map((frase, i) => (
          <span
            key={frase}
            className={i === frases.length - 1 ? 'fin' : undefined}
            style={{ animationDelay: `${RETRASOS_LEMA[i]}s` }}
          >
            {frase}
          </span>
        ))}
      </div>
      {pie && <p className={claseLemaPie}>{pie}</p>}
    </>
  );
}
